import {isEqual} from 'lodash';
import {actionAlert} from '../../ActionAlertsAgingReportsContainer';
import {alertDetails} from '../interfaces';

export const getListOfIndividualSurveyIds = (alerts: alertDetails[]) => {
  return alerts.reduce((acc, curr) => {
    if (curr.individualSurveyId) {
      return [...acc, curr.individualSurveyId]
    } else { return acc }
  }, [])
}

export const getListOfIndividualSurveyIdsFromReport = (alerts: actionAlert[]) => {
  return alerts.reduce((acc, curr) => {
    if (curr.individualSurveyId) {
      return [...acc, curr.individualSurveyId]
    } else { return acc }
  }, [])
}

export const getListOfIndividualSurveyIdsFromStatusReport = (alerts: any[]) => {
  return alerts.reduce((acc, curr) => {
    if (curr.individualSurveyId) {
      return [...acc, curr.individualSurveyId]
    } else { return acc }
  }, [])
}

function prepareCustomerName(customerInfoList: any[], record: alertDetails | actionAlert, customerName: string) {
  const customerResponses = customerInfoList.filter((item) => item.individualSurveyId === record.individualSurveyId)
  if (customerResponses.length > 0) {
    customerResponses.forEach((responseObj) => {
      if (responseObj && responseObj.Response) {
        if (
          !responseObj.ResponseId.includes('phone') &&
          !responseObj.ResponseId.includes('email') &&
          !responseObj.ResponseId.includes('days') &&
          !responseObj.ResponseId.includes('hide')
        ) {
          if (responseObj.Response && responseObj.Response.length > 0) {
            customerName = responseObj.Response;
          }
        }
      }
    })
  }
  return customerName;
}

export const resolveCustomerName = (record: alertDetails, customerInfoList: any[]) => {
  let customerName = ''
  if (!isEmail(record.source && record.individualSurveyId)) {
    // todo: If customerInfoList is loaded -> display name
    customerName = prepareCustomerName(customerInfoList, record, customerName);
  }
  return customerName
}

function compareCustomerNames(sortOrder: string, customerNameA: string, customerNameB: string) {
  if (sortOrder === 'desc') {
    if (customerNameA > customerNameB) {
      return 1
    } else if (customerNameA < customerNameB) {
      return -1
    } else {
      return 0
    }
  }
  if (sortOrder === 'asc') {
    if (customerNameA < customerNameB) {
      return 1
    } else if (customerNameA > customerNameB) {
      return -1
    } else {
      return 0
    }
  }
}

export const compareCustomerName = (recordA: alertDetails, recordB: alertDetails, customerInfoList: any[], sortOrder: string) => {
  const customerNameA = resolveCustomerName(recordA, customerInfoList)
  const customerNameB = resolveCustomerName(recordB, customerInfoList)
  return compareCustomerNames(sortOrder, customerNameA, customerNameB);
}

export const resolveCustomerNameOnReport = (record: actionAlert, customerInfoList: any[]) => {
  let customerName = ''
  if (!isEmail(record.src && record.individualSurveyId)) {
    customerName = prepareCustomerName(customerInfoList, record, customerName);
  }
  return customerName
}

export const compareCustomerNameOnReport = (recordA: actionAlert, recordB: actionAlert, customerInfoList: any[], sortOrder: string) => {
  const customerNameA = resolveCustomerNameOnReport(recordA, customerInfoList)
  const customerNameB = resolveCustomerNameOnReport(recordB, customerInfoList)
  return compareCustomerNames(sortOrder, customerNameA, customerNameB);
}

export const resolveCustomerNameOnStatusReport = (record: any, customerInfoList: any[]) => {
  let customerName = ''
  if (!isEmail(record.src && record.individualSurveyId)) {
    customerName = prepareCustomerName(customerInfoList, record, customerName);
  }
  return customerName
}

export const compareCustomerNameOnStatusReport = (recordA: any, recordB: any, customerInfoList: any[], sortOrder: string) => {
  const customerNameA = resolveCustomerNameOnStatusReport(recordA, customerInfoList)
  const customerNameB = resolveCustomerNameOnStatusReport(recordB, customerInfoList)
  return compareCustomerNames(sortOrder, customerNameA, customerNameB);
}

export const isEmail = (email) => {
  const emailCheckRE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
  return emailCheckRE.test(email);
}

export const isObjectEqual = (a, b) => {
  return isEqual(a, b);
}
